module.exports = __webpack_public_path__ + "b6bfb50697e4cdc6f73f7826e9662499.pdf";